import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { isExternalLink } from '@yme/utils/common';
export const useInfoAlertClick = ({ learnMoreLink }) => {
    const history = useHistory();
    const onInfoAlertClickHandler = useCallback(() => {
        if (!learnMoreLink) {
            return;
        }
        if (isExternalLink(learnMoreLink)) {
            window.location.replace(learnMoreLink);
        }
        else {
            history.push(learnMoreLink);
        }
    }, [learnMoreLink, history]);
    return {
        onInfoAlertClickHandler,
    };
};
